import { css } from "styled-components";
import { dividerColor } from "./color";
export default css(["box-shadow:0 2px 8px ", ";"], dividerColor);
//# sourceMappingURL=shadow.js.map